export enum TypeEffectifEnum {
  PREVISIONNEL = 'PREVISIONNEL',
  FABRICATION = 'FABRICATION',
  FACTURATION = 'FACTURATION'
}
